import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from '../../services/data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { mobilePhoneValidator } from 'src/app/utils/validationUtils/mobilePhoneValidator';

@Component({
  selector: 'app-event-form-popup',
  templateUrl: './event-form-popup.component.html',
  styleUrls: ['./event-form-popup.component.scss', './event-form-popup.component.en.scss'],
})
export class EventFormPopupComponent implements OnInit {
    eventForm: any;
    antiToken: string = '';

    form!: FormGroup;
    loading: boolean = false;
    sentSucceeded: boolean = false;
    resultSendText: string = '';
    resultSendSubText: string = '';

    constructor(
        public dialogRef: MatDialogRef<EventFormPopupComponent>, 
        @Inject(MAT_DIALOG_DATA) public data: { form: any, antitoken: string },
        private fb: FormBuilder,
        private dataService: DataService
        ) {
        this.eventForm = data.form.registrationEventForm;
        this.antiToken = data.antitoken;
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            username: this.eventForm.fullNameRequired ? ['', Validators.required] : [''],
            email: this.eventForm.emailRequired ? ['', [Validators.required, Validators.email]] : ['', Validators.email],
            phone: this.eventForm.phoneRequired ? ['', [Validators.required, mobilePhoneValidator()]] : ['', mobilePhoneValidator()],
            events: this.eventForm.multiSelectOptionsFieldRequired ? ['', Validators.required] : [''],
            radioSelect: this.eventForm.singleSelectOptionsFieldRequired ? ['', Validators.required] : [''],
            toggleButton: [false],
            deliveryInformation: [false]
          });
    }

    closeDialog() {
        this.dialogRef.close();
    }

    onSubmit() {
        if(this.form.invalid) return;

        this.loading = true;
        let request: any = {
          cultureCode: this.dataService.getCultureCode(),
          fullName: this.form.value.username,
          phoneNumber: this.form.value.phone,
          email: this.form.value.email,
          singleSelectOption: this.form.value.radioSelect,
          isDeliveryConfirmation: this.form.value.toggleButton,
          isDeliveryInformationConfirmation: this.form.value.deliveryInformation,
          selectedOption: this.form.value.events,
          formNodeId: this.eventForm.formId,
          recaptchaToken: '',
          pageNodeId: this.eventForm.nodeId
        };

        let url = environment.apiUrl + "/Umbraco/Api/EventFormApi/SubmitEventForm";
        this.dataService.postDataWithRequestVerificationToken(url, request, this.antiToken).subscribe({
            next: (result) => {
              if (result.succeed === true) {
                this.resultSendText = this.eventForm.succeedTitleMessage;
                this.resultSendSubText = this.eventForm.succeedSubTitleMessage;
              }
              else {
                this.resultSendText = this.eventForm.generalErrorMessage;
                this.resultSendSubText = result.errorMessages[0];
              }

              this.clearForm();
            },
            error: (e) => {
              console.error(e);
              this.resultSendText = this.eventForm.generalErrorMessage;
              this.clearForm();
            },
          });
    }

    clearForm() {
      this.loading = false;
      this.sentSucceeded = true;
        setTimeout(() => {
          this.form.reset();
          this.sentSucceeded = false;
      }, 5000);
    }
}
